import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import AuthShell, { Field, Input } from "../components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) return toast.error("Password must be ≥ 6 chars");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset Password" subtitle="Set a new password" footer={<Link to="/login" className="hover:text-[var(--accent)]">← Back to login</Link>}>
      {!token ? (
        <p className="text-sm text-red-600">Invalid or missing token.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="New Password (min 6)">
            <Input type="password" required minLength={6} value={pwd} onChange={e=>setPwd(e.target.value)} data-testid="reset-password" />
          </Field>
          <button type="submit" disabled={loading}
            className="btn-gold w-full rounded-full py-3 text-sm tracking-widest uppercase disabled:opacity-60" data-testid="reset-submit">
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
